import { asyncRoutes, constantRoutes } from "@/router";
import Layout from "@/layout";
import { getMenu } from "@/api/user";
import { Message } from "element-ui";
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  } else {
    return true;
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = [];

  routes.forEach(route => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}


/**
 * 转换为树菜单
 */

function toTree (data) {
  let map = {};
  let newData = [];
  let arr = [];
  data.forEach((item)=> {
    let {
      id,
      parentMenuId,
      path,
      metaTitle,
      metaIcon,
      menuCode,
      parentMenuCode,
      component,
      name,
      isHide,
      metaNoCache
    } = item;
    let obj = {
      id:id,
      parentMenuId:parentMenuId,
      menuCode: menuCode,
      parentMenuCode: parentMenuCode,
      name: name,
      path: parentMenuId == 'rootId' ? '/' + path : path ,
      meta: {
        title: metaTitle,
        icon: metaIcon
      },
      hidden: isHide === 'Y' ? true : false,
      component: parentMenuId === "rootId" ? Layout: (resolve) => require([`@/views/${component}`], resolve)
    };
    if(parentMenuId === "rootId"){
      obj['alwaysShow'] = true;
      
    }else{
     if(metaNoCache === 'Y' ){
      obj['meta']['noCache'] = true;
     }
    }
    map[item.id] = obj;
    newData.push(obj);
  });
  newData.forEach((item)=> {
    let parent = map[item.parentMenuId];
    if (parent) {
      if (!parent.children) {
        parent.children = [];
      }
      parent.children.push(item);
    } else {
      arr.push(item);
    }
  });
  return arr;
}

const state = {
  routes: [],
  addRoutes: []
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  }
};

const actions = {
  generateRoutes({ commit },roles) {
    return new Promise((resolve,reject) => {
      getMenu()
        .then(res => {
          let resData = res.data;
          if (res.code == 0) {
            let {menuList,roleSet} = resData;
            let data = Object.assign([],menuList); 
            let accessedRoutes = toTree(data);
            if (!roleSet || roleSet.length <= 0) {
              Message.error(res.msg || "当前用户未授权访问本系统");
              reject('用户的角色不能为空!');
            }
            commit("user/SET_ROLES", roleSet,{root: true});
            commit("SET_ROUTES", accessedRoutes);
            resolve(accessedRoutes);
          } else {
            Message.error(res.msg || "菜单数据加载异常");
          }
        })
        .catch(error => {
          reject(error);
          console.log(error);
        });
      // let accessedRoutes
      // if (roles.includes('admin') || roles.includes('manager')) {
      //   accessedRoutes = asyncRoutes || []
      // } else {
      //   accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      // }
      // commit('SET_ROUTES', accessedRoutes)
      // resolve(accessedRoutes)
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/permission.js